import { useMemo } from 'react';
import { Tag } from '@care/react-component-lib';
import { Box, SxProps, type Theme } from '@mui/material';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults as ProviderSearchResult } from '@/__generated__/seoSegmentationListingPage';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';
import { shufflePhilosophies } from './helpers/shufflePhilosophies';
import { shuffleSchoolTypes } from './helpers/shuffleSchoolTypes';

export interface SMBServicesProps {
  philosphies: ProviderSearchResult['philosophies'];
  schoolTypes: ProviderSearchResult['schoolTypes'];
  sx?: SxProps<Theme>;
}

export const SMBAttributesTagList = ({ sx, philosphies, schoolTypes }: SMBServicesProps) => {
  const MAX_LIST_LENGTH = 6;
  const { shuffleSeed = 1 } = usePageAttributes();

  const attributes = useMemo(() => {
    const applicablePhilosophies = shufflePhilosophies(philosphies, shuffleSeed);
    const applicableSchoolTypes = shuffleSchoolTypes(schoolTypes, shuffleSeed);

    const attributesList = [...applicablePhilosophies, ...applicableSchoolTypes];
    if (attributesList.length >= MAX_LIST_LENGTH) {
      const overflowCount = attributesList.length - MAX_LIST_LENGTH + 1;
      attributesList.splice(MAX_LIST_LENGTH - 1);
      attributesList.push(`+ ${overflowCount} more`);
    }

    return attributesList;
  }, [philosphies, schoolTypes, shuffleSeed]);

  if (attributes.length === 0) {
    return null;
  }

  return (
    <Box sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      {attributes.map((attribute) => (
        <Tag sx={{ mr: 1 }} key={attribute} type="grey" size="large">
          {attribute}
        </Tag>
      ))}
    </Box>
  );
};
